<template>
  <b-container fluid>
    <b-row style="margin-bottom: 1rem;" align-h="between">
      <template v-if="object.date.options.length > 0">
        <b-col cols="10">
          <span>
            交易日期:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 17vh; display: inline-grid; margin-right: 10px;"
              v-model="object.date.value"
              :options="object.date.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <!-- <span><b-button @click="ifloading = !ifloading">test</b-button></span> -->
        </b-col>
        <b-col cols="auto">
          <b-button-group>
            <b-dropdown
              variant="outline-secondary"
              right
              v-b-tooltip.hover
              title="列表顯示項目"
              class="ml-1"
            >
              <template #button-content>
                <b-icon-table></b-icon-table>
              </template>
              <b-dropdown-form form-class="abc">
                <template v-for="field in object.table.fields">
                  <b-checkbox
                    style="min-width: max-content;"
                    v-if="field.toggleable !== false"
                    :key="field.key"
                    v-model="field.visible"
                    :value="true"
                    :unchecked-value="false"
                    inline
                  >
                    {{ field.label }}
                  </b-checkbox>
                </template>
                <!-- <b-form-checkbox v-for="(item, index) in fields" :key="index">{{item.label}}
                                  </b-form-checkbox> -->
              </b-dropdown-form>
            </b-dropdown>
          </b-button-group>
        </b-col>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
    </b-row>
    <div style="margin-top: 1rem;" v-if="ifshow">
      <!-- <b-overlay :show="chart.ifloading" rounded="sm"> -->
      <template v-if="!ifloading">
        <!-- <span style="width: 35vw; display: inline-block; margin-right: 2rem;">
          <apexchart
            ref="chart1ref"
            type="pie"
            :options="object.chart.donut.options"
            :series="object.chart.donut.series"
          ></apexchart>
        </span>
        <span style="width: 40vw;display: inline-block;">
          <apexchart
            ref="chart2ref"
            type="line"
            :options="object.chart.line.options"
            :series="object.chart.line.series"
          ></apexchart>
        </span> -->
        <b-container fluid>
          <b-row>
            <b-col class="chartdiv" xl="5" lg="12">
              <apexchart
                ref="chart1ref"
                type="pie"
                :options="object.chart.donut.options"
                :series="object.chart.donut.series"
              ></apexchart>
            </b-col>
            <b-col class="chartdiv" xl="6" lg="12">
              <apexchart
                ref="chart2ref"
                type="line"
                :width="chartwidth"
                :options="object.chart.line.options"
                :series="object.chart.line.series"
              ></apexchart>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
      <!-- </b-overlay> -->
    </div>
    <template>
      <b-row>
        <b-col>
          <b-table
            :items="object.table.items"
            :fields="visibleFields"
            :current-page="object.table.currentPage"
            :per-page="object.table.perPage"
            :busy="object.table.isBusy"
            :sort-by.sync="object.table.sortBy"
            :sort-desc.sync="object.table.sortDesc"
            head-variant="green"
            responsive
            striped
            hover
            bordered
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="object.table.currentPage"
            :total-rows="totalData"
            :per-page="object.table.perPage"
            small
          ></b-pagination>
        </b-col>
        <b-col cols="auto">
          <span>共 {{ totalData }}筆資料，每頁顯示</span>
        </b-col>
        <b-col cols="auto">
          <b-form-select
            v-model="object.table.perPage"
            :options="object.table.pageoptions"
            style="min-width: max-content;"
            size="sm"
          ></b-form-select>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      chartwidth: "100%",
      window: {
        width: 1024,
        height: 0,
      },
      ifshow: false,
      ifloading: false,
      object: {
        date: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        table: {
          ifshow: false,
          fields: [
            {
              key: "T_DATE",
              label: "交易日期",
              visible: true,
            },
            {
              key: "MARKET",
              label: "市場名稱",
              visible: true,
            },
            {
              key: "FINAL_NUM",
              label: "成交頭數-總數(頭)",
              visible: true,
            },
            {
              key: "FINAL_WEI",
              label: "成交頭數-平均重量(公斤)",
              visible: true,
            },
            {
              key: "FINAL_PRICE",
              label: "成交頭數-平均價格(元/公斤)",
              visible: true,
            },
            {
              key: "NORMAL_NUM",
              label: "規格豬(75公斤以上)-頭數(頭)",
              visible: true,
            },
            {
              key: "NORMAL_WEI",
              label: "規格豬(75公斤以上)-平均重量(公斤)",
              visible: true,
            },
            {
              key: "NORMAL_PRICE",
              label: "規格豬(75公斤以上)-平均價格(元/公斤)",
              visible: true,
            },
            {
              key: "KG95_NUM",
              label: "95(含)-115(含)-頭數(頭)",
              visible: false,
            },
            {
              key: "KG95_WEI",
              label: "95(含)-115(含)-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG95_PRICE",
              label: "95(含)-115(含)-平均價格(元/價格)",
              visible: false,
            },
            {
              key: "KG75_NUM",
              label: "75公斤以下-頭數(頭)",
              visible: false,
            },
            {
              key: "KG75_WEI",
              label: "75公斤以下-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG75_PRICE",
              label: "75公斤以下-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "KG115_NUM",
              label: "115(含)-135(不含)-頭數(頭)",
              visible: false,
            },
            {
              key: "KG115_WEI",
              label: "115(含)-135(不含)-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG115_PRICE",
              label: "115(含)-135(不含)-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "KG0_NUM",
              label: "75公斤以下-頭數(頭)",
              visible: false,
            },
            {
              key: "KG0_WEI",
              label: "75公斤以下-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG0_PRICE",
              label: "75公斤以下-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "OUT_NUM",
              label: "淘汰種豬-頭數(頭)",
              visible: false,
            },
            {
              key: "OUT_WEI",
              label: "淘汰種豬-平均重量(公斤)",
              visible: false,
            },
            {
              key: "OUT_PRICE",
              label: "淘汰種豬-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "OTHER_NUM",
              label: "其他豬-頭數(頭)",
              visible: false,
            },
            {
              key: "OTHER_WEI",
              label: "其他豬-平均重量(公斤)",
              visible: false,
            },
            {
              key: "OTHER_PRICE",
              label: "其他豬-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "FROZEN_NUM",
              label: "冷凍廠-頭數(頭)",
              visible: false,
            },
            {
              key: "FROZEN_WEI",
              label: "冷凍廠-平均重量(公斤)",
              visible: false,
            },
            {
              key: "FROZEN_PRICE",
              label: "冷凍廠-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "FINAL_NONF_NUM",
              label: "成交總數(不含冷凍廠)-頭數(頭)",
              visible: false,
            },
            {
              key: "FINAL_NONF_WEI",
              label: "成交總數(不含冷凍廠)-平均重量(公斤)",
              visible: false,
            },
            {
              key: "FINAL_NONF_PRICE",
              label: "成交總數(不含冷凍廠)-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "KG135_NUM",
              label: "135(含)-155(不含)-頭數(頭)",
              visible: false,
            },
            {
              key: "KG135_WEI",
              label: "135(含)-155(不含)-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG135_PRICE",
              label: "135(含)-155(不含)-平均價格(元/公斤)",
              visible: false,
            },
            {
              key: "KG155_NUM",
              label: "155公斤以上-頭數(頭)",
              visible: false,
            },
            {
              key: "KG155_WEI",
              label: "155公斤以上-平均重量(公斤)",
              visible: false,
            },
            {
              key: "KG155_PRICE",
              label: "155公斤以上-平均價格(元/公斤)",
              visible: false,
            },
          ],
          sortBy: "T_DATE",
          sortDesc: true,
          items: [],
          allitems: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
        chart: {
          items: [],
          donut: {
            series: [],
            options: {
              chart: {
                type: "pie",
                width: "100%",
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text: "各市場成交頭數占比",
              },
              labels: [],
              colors: [
                "#F94144",
                "#277DA1",
                "#F3722C",
                "#577590",
                "#F8961E",
                "#4D908E",
                "#F9844A",
                "#43AA8B",
                "#F9C74F",
                "#90BE6D",
                "#E8D7CB",
                "#B8B8B8",
                "#AC9477",
                "#7A7A7A",
                "#583A0E",
                "#010C13",
                "#352B1C",
                "#250001",
                "#6F5C5D",
                "#3D0003",
                "#470063",
                "#EABFCB",
                "#FF0A5C",
                "#4f2935",
                "#C191A1",
                "#353229",
                "#9f0b36",
                "#fc05d7",
                "#d2a9f3",
                "#9b6a6c",
              ],
              responsive: [
                {
                  breakpoint: 550,
                  options: {
                    chart: {
                      width: 550,
                    },
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              ],
            },
          },
          line: {
            series: [],
            options: {
              chart: {
                type: "line",
                width: 550,
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text: "各市場成交頭數平均重量/價格",
              },
              dataLabels: {
                enabled: true,
              },
              noData: {
                text: "目前無資料",
                align: "center",
                verticalAlign: "middle",
              },
              yaxis: [
                {
                  seriesName: "平均重量(公斤)",
                  title: {
                    text: "平均重量 ( 公斤 )",
                  },
                },
                {
                  seriesName: "平均價格(元/公斤)",
                  opposite: true,
                  title: {
                    text: "平均價格 ( 元 / 公斤 )",
                  },
                },
              ],
              colors: [
                "#008FFB",
                "#19535f",
                "#FEB019",
                "#FF4560",
                "#775DD0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
              ],
              labels: [],
              responsive: [
                {
                  breakpoint: 550,
                  options: {
                    chart: {
                      width: 550,
                    },
                    legend: {
                      position: "bottom",
                    },
                  },
                },
              ],
            },
          },
        },
      },
      apiGetTradePigDateList: (data) =>
        this.userRequest.post("/API/Default/getTradePigDateList", data),
      apiGetTradePigDataList: (data) =>
        this.userRequest.post("/API/Default/getTradePigDataList", data),
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    totalData() {
      return this.object.table.items.length;
    },
    visibleFields() {
      return this.object.table.fields.filter((field) => field.visible);
    },
  },
  methods: {
    init() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      this.FunctionToken(this.getTradePigDateList, {});
      this.FunctionToken(this.getTradePigDataList, {});
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.object.chart.line.options.chart.width =
        this.window.width > 550 ? "100%" : 550;
    },
    getTradePigDateList(data) {
      this.apiGetTradePigDateList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.date.options = [];

            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.T_DATE,
                code: x.T_DATE,
                disabled: true,
              };
              this.object.date.options.push(obj);
            });
            this.object.date.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
          }
        })
        .catch((err) => console.warn(err));
    },
    getTradePigDataList(data) {
      this.apiGetTradePigDataList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.table.items = JSON.parse(json.Data);
            this.object.table.totalRows = this.object.table.items.length;
            this.object.table.isBusy = false;
            this.ifshow = true;
            this.ifloading = true;
            this.createchart();
          }
        })
        .catch((err) => console.warn(err));
    },
    getDataList() {
      if (this.object.date.value != null) {
        this.object.table.isBusy = true;
        this.FunctionToken(this.getTradePigDataList, {
          T_DATE: this.object.date.value.code,
        });
      }
    },
    createchart() {
      let marketlist = [];
      this.object.table.items.forEach((x) => {
        let index = marketlist.findIndex((y) => y.name == x.MARKET);
        if (index == -1) {
          let obj = {
            name: x.MARKET,
            avg_num: x.FINAL_NUM,
            avg_weight: x.FINAL_WEI,
            avg_price: x.FINAL_PRICE,
          };
          marketlist.push(obj);
        } else {
          let num =
            parseFloat(marketlist[index].avg_num) + parseFloat(x.FINAL_NUM);
          marketlist[index].avg_num = num;
          let wei =
            parseFloat(marketlist[index].avg_weight) + parseFloat(x.FINAL_WEI);
          marketlist[index].avg_weight = wei;
          let finalprice =
            parseFloat(marketlist[index].avg_price) + parseFloat(x.FINAL_PRICE);
          marketlist[index].avg_price = finalprice;
        }
      });

      let chart1list = [],
        chart2list = [],
        chart3list = [],
        chart4list = [];
      marketlist.forEach((x) => {
        chart1list.push(x.name);
        chart2list.push(x.avg_num);
        chart3list.push(Math.round(x.avg_weight * 100) / 100);
        chart4list.push(Math.round(x.avg_price * 100) / 100);
      });
      this.object.chart.donut.options.labels = [];
      this.object.chart.donut.options.labels = chart1list;
      this.object.chart.donut.series = [];
      this.object.chart.donut.series = chart2list;

      this.object.chart.line.options.labels = [];
      this.object.chart.line.options.labels = chart1list;
      this.object.chart.line.series = [];
      // this.object.chart.line.series.push({
      //   name: "平均重量(公斤)",
      //   type: "column",
      //   data: chart3list,
      // });
      this.object.chart.line.series.push({
        name: "平均重量(公斤)",
        type: "line",
        data: chart3list,
      });
      this.object.chart.line.series.push({
        name: "平均價格(元/公斤)",
        type: "line",
        data: chart4list,
      });
      setTimeout(() => {
        this.ifloading = false;
      }, 500);
    },
  },
  watch: {
    "object.date.value"() {
      this.getDataList();
    },
  },
};
</script>

<style>
@media screen and (max-width: 550px) {
  .Info_Area {
    padding: 1rem;
  }
  .chartdiv {
    widows: 100%;
    overflow-x: scroll;
  }
}
</style>
